import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={29 * (props.hx ?? 1)}
    viewBox="0 0 17 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2045_299"
      maskUnits="userSpaceOnUse"
      x="0.766357"
      y="0.33429"
      width="16"
      height="28"
      fill="black"
    >
      <rect fill="white" x="0.766357" y="0.33429" width="16" height="28" />
      <path d="M8.76613 26.6828C9.96501 26.6828 13.0827 28.4027 14.8835 26.2535C16.3266 24.5311 15.7936 20.3891 14.7592 17.6019C14.3744 16.5648 14.3501 15.5781 14.3664 14.459C14.442 9.14129 15.8959 1.83676 14.7592 1.83429C13.6225 1.83182 10.9066 13.6854 8.76659 14.459C7.8939 14.7743 5.76636 10.8343 5.26636 8.33429C4.76636 5.83429 4.45823 1.33429 3.76636 1.33429C3.07449 1.33429 2.77355 5.8343 2.77355 6.83429C2.77355 7.83428 3.12334 12.0799 3.07449 14.459C3.05151 15.5781 3.1583 16.5653 2.77355 17.6019C1.73911 20.3896 1.20612 24.5316 2.64919 26.2535C4.44998 28.4027 7.56725 26.6828 8.76613 26.6828Z" />
    </mask>
    <path
      d="M8.76613 26.6828C9.96501 26.6828 13.0827 28.4027 14.8835 26.2535C16.3266 24.5311 15.7936 20.3891 14.7592 17.6019C14.3744 16.5648 14.3501 15.5781 14.3664 14.459C14.442 9.14129 15.8959 1.83676 14.7592 1.83429C13.6225 1.83182 10.9066 13.6854 8.76659 14.459C7.8939 14.7743 5.76636 10.8343 5.26636 8.33429C4.76636 5.83429 4.45823 1.33429 3.76636 1.33429C3.07449 1.33429 2.77355 5.8343 2.77355 6.83429C2.77355 7.83428 3.12334 12.0799 3.07449 14.459C3.05151 15.5781 3.1583 16.5653 2.77355 17.6019C1.73911 20.3896 1.20612 24.5316 2.64919 26.2535C4.44998 28.4027 7.56725 26.6828 8.76613 26.6828Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M8.76613 26.6828C9.96501 26.6828 13.0827 28.4027 14.8835 26.2535C16.3266 24.5311 15.7936 20.3891 14.7592 17.6019C14.3744 16.5648 14.3501 15.5781 14.3664 14.459C14.442 9.14129 15.8959 1.83676 14.7592 1.83429C13.6225 1.83182 10.9066 13.6854 8.76659 14.459C7.8939 14.7743 5.76636 10.8343 5.26636 8.33429C4.76636 5.83429 4.45823 1.33429 3.76636 1.33429C3.07449 1.33429 2.77355 5.8343 2.77355 6.83429C2.77355 7.83428 3.12334 12.0799 3.07449 14.459C3.05151 15.5781 3.1583 16.5653 2.77355 17.6019C1.73911 20.3896 1.20612 24.5316 2.64919 26.2535C4.44998 28.4027 7.56725 26.6828 8.76613 26.6828Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2045_299)"
    />
  </svg>
);
export default SvgNormal;
